import React from "react";
import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: "#FFFFFF",
          border: "1px solid #E2E4DF",
          color: "#1C1E1B",
          fontFamily: "IBM Plex Sans, sans-serif",
          fontSize: "14px",
        },
      }}
    />
  );
}
